import { bootstrap } from 'slipstream-components';
import { appModels, DefaultProviderFactory } from 'ui-common';
import extensions from './.gen/.extensions';
import routes from './.gen/.routes';

bootstrap(new DefaultProviderFactory(), routes, extensions, appModels.models);
